import React, { Children, cloneElement, isValidElement } from "react";

export const Tabs = ({ value, onChange, children, className = "", ...rest }) => {
  const items = Children.toArray(children).filter(isValidElement);

  return (
    <div
      role="tablist"
      className={`flex items-end gap-1 overflow-x-auto border-b border-farmazon-border ${className}`}
      {...rest}
    >
      {items.map((child, index) => {
        const tabValue = child.props.value !== undefined ? child.props.value : index;
        const isActive = value === tabValue;

        return cloneElement(child, {
          key: tabValue,
          isActive,
          onClick: event => {
            child.props.onClick?.(event);
            onChange?.(event, tabValue);
          },
        });
      })}
    </div>
  );
};

export const Tab = ({ label, isActive, onClick, disabled, className = "", ...rest }) => (
  <button
    type="button"
    role="tab"
    aria-selected={isActive}
    disabled={disabled}
    onClick={onClick}
    className={`shrink-0 appearance-none whitespace-nowrap rounded-none border-0 border-b-2 border-solid bg-transparent px-4 py-2.5 text-sm font-medium outline-none transition-colors ${
      isActive
        ? "border-[var(--primaryColor)] text-[var(--primaryColor)]"
        : "border-transparent text-farmazon-text-muted hover:text-farmazon-text"
    } disabled:cursor-not-allowed disabled:opacity-40 ${className}`}
    {...rest}
  >
    {label}
  </button>
);
